import { render, staticRenderFns } from "./stencilIndex.vue?vue&type=template&id=456d3c3e&scoped=true&"
import script from "./stencilIndex.vue?vue&type=script&lang=js&"
export * from "./stencilIndex.vue?vue&type=script&lang=js&"
import style0 from "./stencilIndex.vue?vue&type=style&index=0&id=456d3c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d3c3e",
  null
  
)

export default component.exports